import React from 'react'
import Image from 'next/image'
import { Header2, Text } from '../../styles/Components'
import Button from '../Button'
import { gsColors as c } from '../../styles/Variables'
import styled from '@emotion/styled'
import { mq } from '../../helpers'
import WeddingImg from '../../../public/how-it-works/wedding_glam.webp'

const WeddingWrapper = styled.section`
  width: 100%;
  max-width: 1600px;
  display: flex;
  flex-direction: row;

  ${mq('max', '768px')} {
    flex-direction: column;
  }

  .content {
    width: 50%;
    background-color: ${c.cobalt};
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 88px;

    ${mq('max', '1024px')} {
      padding: 44px;
    }

    ${mq('max', '768px')} {
      width: 100%;
      padding: 48px 16px;
    }
  }

  .image-placeholder {
    width: 50%;
    position: relative;
    min-height: 509px;
    overflow: hidden;

    ${mq('max', '768px')} {
      width: 100%;
      min-height: 320px;
    }
  }

  .gradient-overlay {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 183px;
    background: linear-gradient(to bottom, rgba(0,0,0,0) 50%, rgba(0,0,0,0.9));
    z-index: 1;

    ${mq('max', '768px')} {
      height: 106px;
    }
  }

  .credit {
    position: absolute;
    bottom: 16px;
    right: 16px;
    z-index: 2;
  }
`

const WeddingGlam = () => (
  <WeddingWrapper>
    <div className="content">
      <Header2 color={c.white} margin="0 0 24px 0">
        Wedding glam?<br />Check.
      </Header2>
      <Text variant="small" lineHeight="145%" color={c.white} spacing={0.16}>
        From the bridal shower to the bachelorette to the big day, our
        white-glove concierge service and bridal-certified beauty pros are
        here for it all.
      </Text>
      <Button
        large
        outline
        color={c.salmon}
        path="/weddings"
        margin="24px 0 0 0"
      >
        Explore Bridal Services
      </Button>
    </div>
    <div className="image-placeholder">
      <Image
        src={WeddingImg}
        alt="Bride receiving Glamsquad wedding hair and makeup services"
        fill
        sizes="(max-width: 768px) 100vw, 50vw"
        style={{ objectFit: 'cover' }}
      />
      <div className="gradient-overlay" />
      <div className="credit">
        <Text variant="small" color={c.white} lineHeight="145%" spacing={0.16}>
          @nalimatoure
        </Text>
      </div>
    </div>
  </WeddingWrapper>
)

export default WeddingGlam
